var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showModal)?_c('div'):(_vm.showModal && _vm.modalType === 'request-offer')?_c('OrganismsProjectOrganismRequestOfferModal'):(_vm.showModal && _vm.modalType === 'download-brochure')?_c('OrganismsProjectOrganismDownloadBrochureModal'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }